import React, { useState } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import styles from "./Slider.module.css";

const images = [
    "https://i.ibb.co/rPcPhgr/IMG1.jpg",
    "https://i.ibb.co/FkTwTttX/IMG.jpg",
    "https://i.ibb.co/p9dkZTH/IMG-3.jpg",
    "https://i.ibb.co/j0CvG09/IMG-8995.jpg",
    "https://i.ibb.co/mr3mzgN5/IMG-8996.jpg",
    "https://kits.edu/UserData/uploads/slider/9.jpg",
  ];

const items = images.map((image, index) => (
  <div key={index} className={styles.slideItem}>
    <img src={image} alt={`Slide ${index + 1}`} className={styles.sliderImage} />
  </div>
));

const Slider = () => {
  return (
    <div className={styles.sliderContainer}>
      <AliceCarousel
        items={items}
        responsive={{
          0: { items: 1 }, // Show 1 item for small screens
          1024: { items: 2 }, // Show 2 items for large screens
        }}
        disableDotsControls
        autoPlay
        autoPlayInterval={1000} // Auto slide every 2.5 seconds
        infinite
        animationDuration={800} // Smooth transition
        paddingLeft={20} // Adds spacing between items
        paddingRight={20}
      />
    </div>
  );
};

export default Slider;
